module.exports = __webpack_public_path__ + "img/SES_220411200.32735414.jpg";